"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * The GridColumnMenuItemGroup that will be used inside the Grid ColumnMenu.
 */
var GridColumnMenuItemGroup = /** @class */ (function (_super) {
    __extends(GridColumnMenuItemGroup, _super);
    function GridColumnMenuItemGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    GridColumnMenuItemGroup.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement("div", { className: "k-columnmenu-item-wrapper" }, children));
    };
    return GridColumnMenuItemGroup;
}(React.Component));
exports.GridColumnMenuItemGroup = GridColumnMenuItemGroup;
//# sourceMappingURL=GridColumnMenuItemGroup.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-grid@3.18.0_v4dt5gqvzldvli3cocmcghfwh4/~/@progress/kendo-react-grid/dist/npm/columnMenu/GridColumnMenuItemGroup.js
// module id = 126
// module chunks = 0